var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifestyle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.6229 2.50835C11.9674 1.16388 14.1472 1.16388 15.4917 2.50835C16.8361 3.85281 16.8361 6.03262 15.4917 7.37709L7.37709 15.4917C6.03262 16.8361 3.85281 16.8361 2.50835 15.4917C1.16388 14.1472 1.16388 11.9674 2.50835 10.6229L10.6229 2.50835Z",
    style: {
      stroke: "var(--color, currentColor)"
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51313 2.67064C9.05091 2.13285 9.92284 2.13285 10.4606 2.67064L8.51313 4.61814C7.97534 4.08035 7.97534 3.20843 8.51313 2.67064Z",
    style: {
      stroke: "var(--color, currentColor)"
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3294 9.48687C15.8671 8.94909 15.8671 8.07716 15.3294 7.53938L13.3819 9.48687C13.9196 10.0247 14.7916 10.0247 15.3294 9.48687Z",
    style: {
      stroke: "var(--color, currentColor)"
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67064 8.51313C3.20843 7.97534 4.08035 7.97534 4.61814 8.51313L2.67064 10.4606C2.13285 9.92284 2.13285 9.05091 2.67064 8.51313Z",
    style: {
      stroke: "var(--color, currentColor)"
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48687 15.3294C10.0247 14.7916 10.0247 13.9196 9.48687 13.3819L7.53938 15.3294C8.07716 15.8671 8.94909 15.8671 9.48687 15.3294Z",
    style: {
      stroke: "var(--color, currentColor)"
    },
    strokeWidth: 1.5
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifestyle);
export default __webpack_public_path__ + "static/media/lifestyle.5d006ac3.svg";
export { ForwardRef as ReactComponent };